import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

export default class FilterReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const fecha = {
            // Configuration for date selection
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date range
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date is today
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const transactionId = {
            // Placeholder for transaction ID section
            margin: 5,
            minWidth: 200,
            rows: [],
        };
        const upper_section = {
            // Upper section containing filters
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [fecha, transactionId], // Including date selection and transaction ID
                },
            ],
        };
        const buttons = {
            // Button configuration for the main filter section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Translated label
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Translated label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('userAffiliates:filter', [
                            filterdata, // Trigger filter event with collected data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            // Button configuration for the popup filter section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button for popup
                    value: _('Limpiar'), // Translated label
                    width: 100,
                    click: () => {
                        $$('myForm2').clear(); // Clears the popup form
                    },
                },
                {
                    view: 'button', // Consult button for popup
                    value: _('Consultar'), // Translated label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get popup form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('userAffiliates:filter', [
                            filterdata, // Trigger filter event with collected data
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            // Accordion section for main filters
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Translated header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            // Accordion section for popup filters
            padding: 10,
            rows: [upper_section, buttons2], // Including upper section and buttons
        };
        const filterPopup = webix.ui({
            // Popup window configuration
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Translated label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // ID for the popup form
                type: 'clean',
                rows: [accordion_section3], // Including accordion section for filters
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            view: 'form', // Main form configuration
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }
    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
